import { useLingui } from '@lingui/react/macro';
import { useSettings } from '@wu/widget-core';

export function useCheckoutErrorText() {
  const { t } = useLingui();
  const { editMode } = useSettings();

  const liveError = t`We’re sorry, the payment page isn’t available right now. Please contact us for assistance.`;
  const editModeError = t`Payment is unavailable due to an invalid price. Update the calculation settings or select a different price source.`;

  if (editMode) {
    return editModeError;
  }

  return liveError;
}
